import Vue from 'vue'
import { base } from '@/layouts'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
 

// vue-chart-3 requirements
import { Chart, registerables } from "chart.js";
import VComp from "@vue/composition-api";
Chart.register(...registerables);
Vue.use(VComp)

Vue.config.productionTip = false

import '@/assets/global.css'
import 'leaflet/dist/leaflet.css';

// VueMask requirements
import VueMask from 'v-mask'
Vue.use(VueMask)

// Vuetify-Money requirements
import "./plugins/vuetify-money.js";

// Setup SimpleGoogleAutocomplete
import { SimpleGoogleAutocomplete } from '@/components/inputs';
Vue.use(SimpleGoogleAutocomplete, {
  apiKey: process.env.VUE_APP_GOOGLE_MAPS_KEY,
  // version: '...', // Optional
  // language: '...', // Optional
  installComponents: true, // Optional (default: true) - false, if you want to locally install components
  vueGoogleMapsCompatibility: false, // Optional (default: false) - true, requires vue2-google-maps to be configured see https://github.com/xkjyeah/vue-google-maps
})

// Setup Stripe
const Stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY)
Vue.use((app) => {
  app.prototype.$stripe = Stripe
})

// Setup formatting library
import formatters from '@/lib/formatters'
Vue.use((app) => {
  app.prototype.$formatters = formatters
})


new Vue({
  router,
  store,
  vuetify,
  render: h => h(base)
}).$mount('#app')

// fix webpack issues with leaflet
import {  Icon } from "leaflet"

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
